import React from "react";
import { Phone, MessageCircle, ArrowUp } from "lucide-react";

export default function FloatingActions() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed right-5 bottom-6 z-40 flex flex-col items-end gap-3">
      {visible && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="w-11 h-11 rounded-full bg-white shadow-md border border-slate-200 flex items-center justify-center text-slate-600 hover:text-[#5c8606] hover:border-[#c4e189] transition-colors"
          aria-label="Scroll to top"
        >
          <ArrowUp className="w-5 h-5" />
        </button>
      )}
      <a href="tel:+919496313677" className="w-12 h-12 rounded-full bg-gradient-to-r from-[#84c009] to-[#4f7700] hover:from-[#70a308] hover:to-[#416200] text-white flex items-center justify-center shadow-lg transition-colors" aria-label="Call">
        <Phone className="w-5 h-5" />
      </a>
      <a href="https://wa.me/919496313677" target="_blank" rel="noreferrer" className="w-12 h-12 rounded-full bg-green-500 hover:bg-green-600 text-white flex items-center justify-center shadow-lg transition-colors" aria-label="WhatsApp">
        <MessageCircle className="w-5 h-5" />
      </a>
    </div>
  );
}
